import { interpolate, escapeHtml } from './utils';

describe('Onboarding utils', () => {
  describe('interpolate', () => {
    it('replaces every occurrence of a %{name} token', () => {
      expect(
        interpolate('Add this %{channel}; the %{channel} is required', {
          channel: 'email address',
        }),
      ).toBe('Add this email address; the email address is required');
    });

    it('replaces multiple distinct tokens', () => {
      expect(
        interpolate('The %{channel} %{value} is taken', {
          channel: 'email',
          value: 'a@b.com',
        }),
      ).toBe('The email a@b.com is taken');
    });

    it('returns an empty string when the template is missing', () => {
      expect(interpolate(undefined, { channel: 'email' })).toBe('');
    });

    it('coerces a missing variable value to an empty string, not "undefined"', () => {
      expect(interpolate('Add this %{channel}', { channel: undefined })).toBe(
        'Add this ',
      );
    });
  });

  describe('escapeHtml', () => {
    it('escapes HTML-significant characters', () => {
      expect(escapeHtml('<script>"x"&\'y\'</script>')).toBe(
        '&lt;script&gt;&quot;x&quot;&amp;&#39;y&#39;&lt;/script&gt;',
      );
    });

    it('coerces null/undefined to an empty string', () => {
      expect(escapeHtml(null)).toBe('');
      expect(escapeHtml(undefined)).toBe('');
    });
  });
});
